import { useParams } from 'next/navigation'
import { stringifyUrl } from 'query-string'
import { useCallback } from 'react'

import { FILTERS_QUERY_PARAM } from '../../../../../../../brunswick/constants'

export function useGenerateFilterSelectionPath() {
  const params = useParams<{ collectionHandle?: string }>()

  const generateFilterSelectionPath = useCallback(
    (filterName: string, value: string): string => {
      if (!params?.collectionHandle) return ''
      return stringifyUrl({
        url: `/collections/${params.collectionHandle}`,
        query: {
          [FILTERS_QUERY_PARAM]: JSON.stringify({
            [filterName]: [value],
          }),
        },
      })
    },
    [params?.collectionHandle]
  )

  return generateFilterSelectionPath
}
